import {
  GetTemplateDocumentUrlRequest,
  GetTemplateDocumentUrlResponse,
  ensureTemplateCorn,
} from '@eigtech/templates-types'
import { contextualGet, queryOptions, useQuery, useQueryClient } from '@eigtech/ui-shared-api'
import { templatesBasePath, templatesQueryKeys } from './constants'

export type UseGetTemplateDocumentUrlProps = {
  templateId: string
}

const getTemplateDocumentUrl = ({ id }: GetTemplateDocumentUrlRequest) =>
  contextualGet<GetTemplateDocumentUrlResponse>(`${templatesBasePath}/${id}/document-url`)

export function getTemplateDocumentUrlQueryOptions({ templateId }: UseGetTemplateDocumentUrlProps) {
  const templateCorn = ensureTemplateCorn(templateId)
  return queryOptions({
    queryKey: templatesQueryKeys.documentUrl({ templateCorn }),
    queryFn: () => getTemplateDocumentUrl({ id: templateCorn }),
    enabled: !!templateCorn,
  })
}

export const useGetTemplateDocumentUrl = (props: UseGetTemplateDocumentUrlProps) =>
  useQuery(getTemplateDocumentUrlQueryOptions(props))

export function useInvalidateTemplateDocumentUrl() {
  const queryClient = useQueryClient()

  return function invalidateTemplateDocumentUrl(props: UseGetTemplateDocumentUrlProps) {
    queryClient.invalidateQueries({
      queryKey: getTemplateDocumentUrlQueryOptions(props).queryKey,
    })
  }
}
